var chunkMapping = {
	"3104": [
		63104
	],
	"7639": [
		31217,
		5369,
		12637,
		8761,
		43991,
		35981,
		50273,
		27133,
		38479,
		40457,
		62142
	],
	"9472": [
		39209,
		85810,
		94217
	]
};
var idToExternalAndNameMapping = {
	"5369": [
		"default",
		"./operations_setting",
		29923
	],
	"8761": [
		"default",
		"./operations_safety",
		76853
	],
	"12637": [
		"default",
		"./operations_lease",
		57263
	],
	"27133": [
		"default",
		"./operations_applet",
		90193
	],
	"31217": [
		"default",
		"./operations_social",
		29947
	],
	"35981": [
		"default",
		"./operations_data",
		44617
	],
	"38479": [
		"default",
		"./operations_capsule",
		83991
	],
	"39209": [
		"default",
		"./hooks",
		37707
	],
	"40457": [
		"default",
		"./routes",
		18325
	],
	"43991": [
		"default",
		"./operations_construct",
		45611
	],
	"50273": [
		"default",
		"./operations_carrier",
		85171
	],
	"62142": [
		"default",
		"./routes",
		19651
	],
	"63104": [
		"default",
		"./charts",
		37707
	],
	"85810": [
		"default",
		"./utils",
		37707
	],
	"94217": [
		"default",
		"./ui",
		37707
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}